/**
 * Feed 页面翻译
 */

import type { TranslationDict } from '../types';

export const feed: TranslationDict = {
  // 页面标题
  pageTitle: {
    en: 'Feed',
    'zh-CN': '动态',
    ja: 'フィード',
  },

  // Tab标签
  tabs: {
    forYou: {
      en: 'For You',
      'zh-CN': '推荐',
      ja: 'おすすめ',
    },
    trending: {
      en: 'Trending',
      'zh-CN': '热门',
      ja: 'トレンド',
    },
    following: {
      en: 'Following',
      'zh-CN': '关注',
      ja: 'フォロー中',
    },
    circles: {
      en: 'Circles',
      'zh-CN': '圈子',
      ja: 'サークル',
    },
  },

  // 发帖框
  createPost: {
    placeholder: {
      en: "What's happening?",
      'zh-CN': '分享你的新鲜事...',
      ja: '何が起きていますか？',
    },
    submit: {
      en: 'Post',
      'zh-CN': '发布',
      ja: '投稿',
    },
    submitting: {
      en: 'Posting...',
      'zh-CN': '发布中...',
      ja: '投稿中...',
    },
  },

  // 加载状态
  loading: {
    en: 'Loading...',
    'zh-CN': '加载中...',
    ja: '読み込み中...',
  },
  loadMore: {
    en: 'Load more',
    'zh-CN': '加载更多',
    ja: 'もっと読み込む',
  },
  noMore: {
    en: 'No more posts',
    'zh-CN': '没有更多内容了',
    ja: 'これ以上投稿はありません',
  },

  // 空状态
  empty: {
    title: {
      en: 'No posts yet',
      'zh-CN': '暂无动态',
      ja: 'まだ投稿がありません',
    },
    description: {
      en: 'Be the first to share something!',
      'zh-CN': '成为第一个分享的人吧！',
      ja: '最初の投稿者になりましょう！',
    },
  },

  // 文章区域
  articles: {
    title: {
      en: 'Latest Articles',
      'zh-CN': '最新文章',
      ja: '最新記事',
    },
    readTime: {
      en: 'min read',
      'zh-CN': '分钟阅读',
      ja: '分で読める',
    },
  },

  // 深度阅读
  deepReads: {
    en: 'Deep Reads',
    'zh-CN': '深度阅读',
    ja: '深読み',
  },

  // 刷新
  refresh: {
    en: 'Refresh feed',
    'zh-CN': '刷新动态',
    ja: 'フィードを更新',
  },

  // 全部看完
  allCaughtUp: {
    en: "You're all caught up!",
    'zh-CN': '你已追上所有动态！',
    ja: 'すべて追いつきました！',
  },

  // 创建帖子模态框
  modal: {
    title: {
      en: 'Create Post',
      'zh-CN': '发布动态',
      ja: '投稿を作成',
    },
    cancel: {
      en: 'Cancel',
      'zh-CN': '取消',
      ja: 'キャンセル',
    },
  },

  // 错误
  error: {
    loadFailed: {
      en: 'Failed to load feed',
      'zh-CN': '加载动态失败',
      ja: 'フィードの読み込みに失敗しました',
    },
    retry: {
      en: 'Retry',
      'zh-CN': '重试',
      ja: '再試行',
    },
  },
};
